export default __webpack_public_path__ + "static/media/trash-full.17206326.svg";